export default __webpack_public_path__ + "static/media/lips-app.efb4b2a5.png";